import { Controller } from "@hotwired/stimulus";

// Fetches company default values and populates hint text on override fields.
// Used on the team form so support staff can see what a team inherits
// without leaving the page.
//
// Usage:
//   data-controller="support--company-defaults"  (on the <form>)
//   data-action="change->support--company-defaults#fetch"  (on the company <select>)
//   data-support--company-defaults-target="hint" data-field="pricing_model"  (on each hint <span>)
export default class extends Controller {
  static targets = ["hint"];

  async fetch(event) {
    const companyId = event.target.value;

    if (!companyId) {
      this.clearHints();
      return;
    }

    const response = await fetch(`/support/companies/${companyId}/defaults`, {
      headers: { Accept: "application/json" },
    });

    if (!response.ok) {
      this.clearHints();
      return;
    }

    const defaults = await response.json();

    this.hintTargets.forEach((hint) => {
      const value = defaults[hint.dataset.field];
      hint.textContent = value ? `Company default: ${value}` : "";
    });
  }

  clearHints() {
    this.hintTargets.forEach((hint) => (hint.textContent = ""));
  }
}
